'use strict';

const Timer = require('./timer');

const inlineUMS = {
  init(payload, done) {
    Timer();
    done();
  },
};

module.exports = inlineUMS;
